jQuery(document).ready(function ($) {

    /**
     * Поиск
     */
    let btnSearch = $('.btn-search');
    btnSearch.on('click', function () {
        $('.quick-search').addClass('active').find('form input').focus();
        $(this).hide();
    });

    $('.btn-search-close').on('click', function (e) {
        e.preventDefault();
        $('.quick-search').removeClass('active');
        btnSearch.show();
    });

    $('.quick-search input').on('blur', function () {
        $('.quick-search').removeClass('active');
        btnSearch.show();
    });

    let inputs = $('.quick-search input, #search-main input');

    inputs.on('blur', function () {
        $(this).closest('form').find('.search-results, .no-results').fadeOut();
    });

    inputs.on('focus', function () {
        $(this).closest('form').find('.search-results, .no-results').fadeIn();
    });

    /**
     * Слайдер отзывов
     */
    let sliderReviews = $('#slider-reviews');
    sliderReviews.slick({
        dots: true,
        arrows: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });

    $('#reviews .slick-prev').on('click', function (e) {
        e.preventDefault();
        sliderReviews.slick('slickPrev');
    });
    $('#reviews .slick-next').on('click', function (e) {
        e.preventDefault();
        sliderReviews.slick('slickNext');
    });

    /**
     * Слайдер элементов в мобильной версии
     */
    let sliderItems = $('.slider-items');
    let sliderItemsSettings = {
        dots: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    sliderItems.slick(sliderItemsSettings);

    /**
     * FAQ
     */
    $('.question').on('click', function () {
        let parent = $(this).closest('.faq');
        parent.siblings().find('.question').removeClass('active');
        parent.siblings().find('.answer').slideUp();
        $(this).toggleClass('active').next().slideToggle();
    });

    /**
     * Меню для мобильного
     */
    $('.btn-menu').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('#header .container').toggleClass('active');
        $('#header .menu, #header .buttons').slideToggle();
    });

    /**
     * Меню в подвале
     */
    $('.list-title').on('click', function () {
        if ($(window).width() < 768) {
            $(this).toggleClass('active').next().slideToggle();
        }
    });

    /**
     * Фильтр в мобильной версии
     */
    $('.btn-filter').on('click', function () {
        $(this).toggleClass('active');
        $('#sidebar').slideToggle();
    });
    /**
     * Дроп списки
     */
    $('.drop-toggle').on('click', function () {
        $(this).toggleClass('active');
        $(this).closest('div').find('.drop-list').toggleClass('active').slideToggle();
    });

    /**
     * Вопрос/ответ в карточке
     */
    $('.answer-form textarea, .question-form textarea').on('focus', function () {
        $(this).closest('form').addClass('active');
    });

    $('.answer-form .btn-gray, .question-form .btn-gray').on('click', function () {
        $(this).closest('form').removeClass('active');
    });


    /**
     * Табы
     */
    $('#tabs').on('click', 'li:not(.active)', function () {
        let $thisTab = $(this).addClass('active').siblings().removeClass('active').parents().find('.tab-box').eq($(this).index());

        if ($(window).width() < 1200) {
            let sliderItems = $thisTab.find('.slider-items');

            $thisTab.fadeIn(150).siblings('.tab-box').hide();

            if (sliderItems.length) {
                sliderItems.slick('unslick');
                sliderItems.slick(sliderItemsSettings)
            }
        } else {
            $('html, body').animate({
                scrollTop: $thisTab.offset().top
            }, 500);
        }

    });

    /**
     * Кнопка вверх
     */
    $(window).on('scroll', function () {
        if ($(window).scrollTop() > 300) {
            $('.btn-up').addClass('active');
        } else {
            $('.btn-up').removeClass('active');
        }
    });

    $('.btn-up').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    });

    /**
     * Календарь
     */
    $.datepicker.regional[ 'ru' ] = {
        dateFormat: 'd M y',
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: '',
        closeText: 'Закрыть',
        prevText: 'Пред',
        nextText: 'След',
        currentText: 'Сегодня',
        monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
            'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
            'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        dayNames: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
        dayNamesShort: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
        dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        weekHeader: 'Нед',
    };
    $.datepicker.setDefaults($.datepicker.regional[ 'ru' ]);

    $('#datepicker').datepicker();

    /**
     * Рейгитнг
     */
    $('.stars.clickable svg').on('click', function () {
        let $this = $(this);
        $this.closest('.stars').attr('data-rating', $this.data('value'));
    });

    /**
     * файл
     */
    $('.images-area').on('click', function () {
        $('#file').click();
    });

    /**
     * Подсказка
     */
    $('.icon-tooltip').on('click', function () {
        $(this).next().slideToggle();
    });

    /**
     * Селект
     */
    $('select').styler();
});
